import { atomWithReset } from "jotai/utils";

import type { SellerListItem } from "../types";

export const deleteSellerModalAtom = atomWithReset<{
  visible: boolean;
  data: SellerListItem | null;
}>({
  visible: false,
  data: null
});
